<template>
    <div>
        <v-autocomplete variant="outlined" density="compact" v-model="selected" :items="contact_items"
            :label="label || t('contact')" clearable>
            <template #append-inner>
                <v-btn icon="mdi-plus" size="x-small" variant="text" :title="t('new_contact')"
                    @click.stop="open_dialog" />
            </template>
        </v-autocomplete>

        <v-dialog v-model="dialog" max-width="500">
        <v-card>
            <v-card-title>{{ t('new_contact') }}</v-card-title>
            <v-card-text>
                <v-form ref="form">
                    <v-text-field class="mb-1" variant="outlined" density="compact" :label="t('name')"
                        :rules="[rules.required]" v-model="form.name" />
                    <v-text-field class="mb-1" variant="outlined" density="compact" :label="t('phone')"
                        v-model="form.phone" />
                    <v-text-field variant="outlined" density="compact" :label="t('email')" v-model="form.email" />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="accent" variant="flat" :loading="saving" :disabled="saving" @click="create_contact">
                    <v-icon start>mdi-check</v-icon>
                    {{ t('save') }}
                </v-btn>
                <v-btn color="secondary" variant="text" @click="dialog = false">{{ t('close') }}</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { useCompanyStore } from "@/stores/company";
import { usePitStoreBasics } from "@/stores/app_common";
import { mapState } from "pinia";

export default {
    setup() { return { ...usePitStoreBasics(), company_store: useCompanyStore() } },
    props: {
        modelValue: { default: null },
        label: { type: String, default: "" },
    },
    data: () => ({
        selected: null,
        dialog: false,
        saving: false,
        form: { name: "", phone: "", email: "" },
        rules: { required: (v) => !!v || "required" },
    }),
    computed: {
        ...mapState(useCompanyStore, ["contacts"]),
        contact_items() {
            return this.contacts.map((c) => ({
                title: c.phone ? `${c.name} — ${c.phone}` : c.name,
                value: c.uuid,
            }));
        },
    },
    watch: {
        selected(v) {
            this.$emit("update:modelValue", v);
        },
        modelValue: {
            handler: function (v) {
                this.selected = v;
            },
            immediate: true,
        },
    },
    methods: {
        open_dialog() {
            this.form = { name: "", phone: "", email: "" };
            this.dialog = true;
        },
        async create_contact() {
            const { valid } = await this.$refs.form.validate();
            if (!valid) return;
            this.saving = true;
            const res = await this.company_store.postContact({ ...this.form });
            this.saving = false;
            if (res?.data) {
                this.selected = res.data.uuid;
                this.dialog = false;
            }
        },
    },
};
</script>
